import type { KeyboardEvent } from 'react';
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, IconButton, Tooltip } from '@rtkwlf/fenrir-react';
import { faChevronRight } from '@rtkwlf/pro-solid-svg-icons/faChevronRight';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { EventKey } from 'ae-constants/constants';

export const DetailLinkIcon: React.FC<{
  to: string;
  labelKey?: string;
  onClick?: () => void;
}> = ({ to, labelKey, onClick }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(to);
    }
  };

  const handleEnter = (e: KeyboardEvent) => {
    if (e.key === EventKey.Return) {
      handleClick();
    }
  };

  return labelKey ? (
    <Button variant="link" onClick={handleClick} onKeyPress={handleEnter}>
      {t(labelKey)}
    </Button>
  ) : (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
        <IconButton
          aria-label={t('icon:navigateToDetails')}
          appearance="default"
          onClick={handleClick}
          onKeyPress={handleEnter}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </IconButton>
      </Tooltip.Trigger>
      <Tooltip.Content>
        <Tooltip.Text>{t('icon:navigateToDetails')}</Tooltip.Text>
      </Tooltip.Content>
    </Tooltip.Root>
  );
};
